import styled from '@emotion/styled';

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  background-color: rgba(255, 255, 255, 0.07);
  box-shadow: 0px 26px 59px 0px rgba(0, 0, 0, 0.18);
`;
